module.exports = __webpack_public_path__ + "img/CTN.aa84395a.png";